import React, { ReactNode } from 'react'
import './footerlinks.css';

interface Props {
    children : ReactNode
    heading  : string;
}

export class FooterLinks extends React.Component<Props> {

    render() {
        return (
            <div className="footerlinks">
                <span className="footer-heading">{ this.props.heading }</span>
                { this.props.children }
            </div>
        );
    }
}

